const POINTS_PER_DECADE_63 /* vs 50 */ = [
  // by 0.05 (mostly)
  1.0, 1.05, 1.1, 1.15, 1.2, 1.25, 1.3, 1.35, 1.4, 1.45, 1.5, 1.55, 1.6, 1.65, 1.7, 1.75, 1.8, 1.85, 1.9, 1.95, 2.0,
  // by 0.10
  2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2,
  // by 0.15
  3.35, 3.5, 3.7, 3.85, 4.0, 4.15, 4.3,
  // by 0.20 (mostly)
  4.5, 4.7, 4.85, 5.0, 5.2, 5.4, 5.6, 5.8, 6.0,
  // by 0.25
  6.25, 6.5, 6.75, 7.0, 7.25, 7.5, 8.0, 8.25, 8.5, 8.75, 9.0, 9.25, 9.75, 10.0,
];

const POINTS_PER_DECADE_99 /* vs 101 */ = [
  // by 0.02
  1.0, 1.02, 1.04, 1.06, 1.08, 1.1,
  // by 0.025 (0.02/0.03/0.03/0.02)
  1.12, 1.15, 1.18, 1.2, 1.22, 1.25, 1.28, 1.3, 1.32, 1.35, 1.38, 1.4, 1.42, 1.45, 1.48, 1.5,
  // by 0.05
  1.55, 1.6, 1.65, 1.7, 1.75, 1.8, 1.85, 1.9, 1.95, 2.0, 2.05, 2.1, 2.15, 2.2, 2.25, 2.3, 2.35, 2.4, 2.45, 2.5, 2.55,
  2.6, 2.7, 2.75, 2.8, 2.85, 2.9, 2.95, 3.0, 3.05, 3.1, 3.15, 3.2,
  // by 0.10
  3.3, 3.4, 3.5, 3.6, 3.7, 3.9, 4.0, 4.1, 4.2,
  // by 0.125 (0.12/0.13/0.13/0.12)
  4.32, 4.45, 4.58, 4.75, 4.88, 5.0,
  // by 0.15
  5.15, 5.3, 5.5, 5.65, 5.8, 6.0, 6.15, 6.3, 6.45, 6.6, 6.75, 6.88, 7.0, 7.15, 7.32, 7.5, 7.65, 7.8,
  //by 0.20
  8.0, 8.2, 8.4, 8.6, 8.8, 9.0, 9.2, 9.4, 9.6, 9.8, 10,
];

const POINTS_PER_DECADE_607 /* vs 603 */ = [
  // by 0.005
  1.005, 1.01, 1.015, 1.02, 1.025, 1.03, 1.035, 1.04, 1.045, 1.05, 1.055, 1.06, 1.065, 1.07, 1.075, 1.08, 1.085, 1.09,
  1.095, 1.1, 1.105, 1.11, 1.115, 1.12, 1.125, 1.13, 1.135, 1.14, 1.145, 1.15, 1.155, 1.16, 1.165, 1.17, 1.175, 1.18,
  1.185, 1.19, 1.195, 1.2, 1.205, 1.21, 1.215, 1.22, 1.225, 1.23, 1.235, 1.24, 1.245, 1.25, 1.255, 1.26, 1.265, 1.27,
  1.275, 1.28, 1.285, 1.29, 1.295, 1.3, 1.305, 1.31, 1.315, 1.32, 1.325, 1.33, 1.335, 1.34, 1.345, 1.35, 1.355, 1.36,
  1.365, 1.37, 1.375, 1.38, 1.385, 1.39, 1.395, 1.4, 1.405, 1.41, 1.415, 1.42, 1.425, 1.43, 1.435, 1.44, 1.445, 1.45,
  1.455, 1.46, 1.465, 1.47, 1.475, 1.48, 1.485, 1.49, 1.495, 1.5, 1.505, 1.51, 1.515, 1.52, 1.525, 1.53, 1.535, 1.54,
  1.545, 1.55, 1.555, 1.56, 1.565, 1.57, 1.575, 1.58, 1.585, 1.59, 1.595, 1.6,
  // by 0.0075  (.008/.007/0.007/0.008)
  1.608, 1.615, 1.622, 1.63, 1.638, 1.645, 1.652, 1.66, 1.668, 1.675, 1.682, 1.69, 1.698, 1.705, 1.712, 1.72, 1.728,
  1.735, 1.742, 1.75, 1.758, 1.765, 1.772, 1.78, 1.788, 1.795, 1.802, 1.81, 1.818, 1.825, 1.832, 1.84, 1.848, 1.855,
  1.862, 1.87, 1.878, 1.885, 1.892, 1.9, 1.908, 1.915, 1.922, 1.93, 1.938, 1.945, 1.952, 1.96, 1.968, 1.975, 1.981,
  1.987, 1.993, 2.0, 2.006, 2.013, 2.02, 2.028, 2.035, 2.042, 2.05, 2.057, 2.065, 2.072, 2.08, 2.088, 2.095, 2.102,
  2.11, 2.118, 2.125, 2.133, 2.14, 2.148, 2.155, 2.162, 2.17, 2.178, 2.185, 2.192, 2.2, 2.208, 2.216, 2.225, 2.231,
  2.238, 2.244, 2.25, 2.259, 2.267, 2.275, 2.282, 2.29, 2.298, 2.305, 2.312, 2.32, 2.328, 2.335, 2.342, 2.35, 2.358,
  2.365, 2.372, 2.38,
  // by 0.01
  2.39, 2.4, 2.41, 2.42, 2.43, 2.44, 2.45, 2.46, 2.47, 2.48, 2.49, 2.5, 2.51, 2.52, 2.53, 2.54, 2.55, 2.56, 2.57, 2.58,
  2.59, 2.6, 2.61, 2.62, 2.63, 2.64, 2.65, 2.66, 2.67, 2.68, 2.69, 2.7, 2.71, 2.72, 2.73, 2.74, 2.75, 2.76, 2.77, 2.78,
  2.79, 2.8, 2.81, 2.82, 2.83, 2.84, 2.85, 2.86, 2.87, 2.88, 2.89, 2.9, 2.91, 2.92, 2.93, 2.94, 2.95, 2.96, 2.97, 2.98,
  2.99, 3.0, 3.01, 3.02, 3.03, 3.04, 3.05, 3.06, 3.07, 3.08, 3.09, 3.1, 3.11, 3.12, 3.13, 3.14, 3.15, 3.16, 3.17, 3.18,
  3.19, 3.2, 3.21, 3.22, 3.23, 3.24, 3.25, 3.26, 3.27, 3.28, 3.29, 3.3, 3.31, 3.32, 3.33, 3.34, 3.35, 3.36, 3.37, 3.38,
  3.39,
  // by 0.02
  3.4, 3.42, 3.44, 3.46, 3.48, 3.5, 3.52, 3.54, 3.56, 3.58, 3.6, 3.62, 3.64, 3.66, 3.68, 3.7, 3.72, 3.74, 3.76, 3.78,
  3.8, 3.82, 3.84, 3.86, 3.88, 3.9, 3.92, 3.93, 3.96, 3.98, 4.0, 4.02, 4.04, 4.06, 4.08, 4.1, 4.12, 4.14, 4.16, 4.18,
  4.2, 4.22, 4.24, 4.26, 4.28, 4.3, 4.32, 4.34, 4.36, 4.38, 4.4, 4.42, 4.44, 4.46, 4.48, 4.5, 4.52, 4.54, 4.56, 4.58,
  4.6, 4.62, 4.64, 4.66, 4.68, 4.7, 4.72, 4.74, 4.76, 4.78, 4.8, 4.82, 4.84, 4.86, 4.88, 4.9, 4.92, 4.94, 4.96, 4.98,
  5.0, 5.02, 5.04, 5.06, 5.08, 5.1, 5.12, 5.14, 5.16, 5.18, 5.2, 5.22, 5.24, 5.26, 5.28, 5.3, 5.32, 5.34, 5.36, 5.38,
  5.4, 5.42, 5.44, 5.46, 5.48, 5.5, 5.52, 5.54, 5.56, 5.58, 5.6, 5.62, 5.64, 5.66, 5.68, 5.7, 5.72, 5.74, 5.76, 5.78,
  5.8, 5.82, 5.84, 5.86, 5.88, 5.9, 5.92, 5.94, 5.96, 5.98, 6.0, 6.02, 6.04, 6.06, 6.08, 6.1, 6.12, 6.14, 6.16, 6.18,
  6.2, 6.22, 6.24, 6.26, 6.28, 6.3, 6.32, 6.34, 6.36, 6.38, 6.4, 6.42, 6.44, 6.46, 6.48, 6.5, 6.52, 6.54, 6.56, 6.58,
  6.6, 6.62, 6.64, 6.66, 6.68, 6.7, 6.72, 6.74, 6.76, 6.78, 6.8, 6.82, 6.84, 6.86, 6.88, 6.9, 6.92, 6.94, 6.96, 6.98,
  7.0,
  // 0.025 => (0.02/0.03/0.03/0.02)
  7.02, 7.05, 7.08, 7.1, 7.12, 7.15, 7.18, 7.2, 7.22, 7.25, 7.28, 7.3, 7.32, 7.35, 7.38, 7.4, 7.42, 7.45, 7.48, 7.5,
  7.52, 7.55, 7.58, 7.6, 7.62, 7.65, 7.68, 7.7, 7.72, 7.75, 7.78, 7.8, 7.82, 7.85, 7.88, 7.9, 7.92, 7.95, 7.98, 8.0,
  8.02, 8.05, 8.08, 8.1, 8.12, 8.15, 8.18, 8.2, 8.22, 8.25, 8.28, 8.3, 8.32, 8.35, 8.38, 8.4, 8.42, 8.45, 8.48, 8.5,
  8.52, 8.55, 8.58, 8.6, 8.62, 8.65, 8.68, 8.7, 8.72, 8.75, 8.78, 8.8, 8.82, 8.85, 8.88, 8.9, 8.92, 8.95, 8.98, 9.0,
  // 0.05
  9.05, 9.1, 9.15, 9.2, 9.25, 9.3, 9.35, 9.4, 9.45, 9.5, 9.55, 9.6, 9.65, 9.7, 9.75, 9.8, 9.85, 9.9, 9.95, 10.0,
];

/**
 * Total of 63 points per decade
 * @param {*} start first frequency in array
 * @param {*} stop last frequency in array.  Must be bigger than start.
 * @param {*} expectedPoints (optional): Array of points that are expected in each decade.  Overrides POINTS_PER_DECADE constant.  For example passing in [1,2] will result in 1, 2, 10, 20, 100, 200, etc.
 */
export function generateModerateGranularityFreqArray(start, stop, expectedPoints) {
  return generateFreqArray(start, stop, expectedPoints, POINTS_PER_DECADE_63);
}

/**
 * Total of 99 points per decade
 * @param {*} start first frequency in array
 * @param {*} stop last frequency in array.  Must be bigger than start.
 * @param {*} expectedPoints (optional): Array of points that are expected in each decade.  Overrides POINTS_PER_DECADE constant.  For example passing in [1,2] will result in 1, 2, 10, 20, 100, 200, etc.
 */
export function generateFineGranularityFreqArray(start, stop, expectedPoints) {
  return generateFreqArray(start, stop, expectedPoints, POINTS_PER_DECADE_99);
}

/**
 * Total of 607 points per decade
 * @param {*} start first frequency in array
 * @param {*} stop last frequency in array.  Must be bigger than start.
 * @param {*} expectedPoints (optional): Array of points that are expected in each decade.  Overrides POINTS_PER_DECADE constant.  For example passing in [1,2] will result in 1, 2, 10, 20, 100, 200, etc.
 */
export function generateExtremelyFineGranularityFreqArray(start, stop, expectedPoints) {
  return generateFreqArray(start, stop, expectedPoints, POINTS_PER_DECADE_607);
}

function generateFreqArray(start, stop, expectedPoints, pointsPerDecade) {
  // error checking
  if (typeof start !== 'number') throw new Error('Cannot generate frequency array, start freq is not a number');
  if (typeof stop !== 'number') throw new Error('Cannot generate frequency array, stop freq is not a number');

  if (start <= 0) throw new Error('Cannot generate frequency array when start freq is <= 0');
  if (start >= stop) throw new Error('Cannot generate frequency array when start frequency is >= stop frequency');

  let results = [],
    currentPosition = start;

  const expectedPointsArr = expectedPoints || pointsPerDecade;

  let decadeStart = Math.floor(Math.log10(start));

  // Iterate through each decade and add the corresponding point values
  for (let decade = decadeStart; currentPosition <= Math.ceil(stop); decade++) {
    let newPoints = expectedPointsArr
      .map((value) => Number(value + 'e' + decade))
      .filter((value) => !results.includes(value)); // ensure we aren't adding duplicates

    results.push(...newPoints);
    currentPosition = results[results.length - 1] + 1;
  }

  // find index of the nearest start value
  const index = results.findIndex((value) => value >= start);
  // if index is not 0, get the value before the index result above, this index will be the starting point of the array
  const startIndex = index === 0 ? index : index - 1;
  const endIndex = results.findIndex((value) => value >= stop);

  const filteredResult = results.filter((_value, index) => {
    return index >= startIndex && index <= endIndex;
  });

  return filteredResult;
}
